// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAddPaymentButton_root__9etmE","text__mMmLw":"PlasmicAddPaymentButton_text__mMmLw__P4+Qk","text__nef5I":"PlasmicAddPaymentButton_text__nef5I__dbHSw"};